module.exports = __webpack_public_path__ + "static/media/anoop_img.d77a92d2.png";